import React, { useContext, useState } from "react";
import styles from "./ShareModal.module.scss";
import { AppContext } from "../../context/AppContext";
import Modal from "react-modal";
import { ReactComponent as whatsappIcon } from "../../assets/whatsapp.svg";
import { ReactComponent as emailIcon } from "../../assets/email.svg";
import { ReactComponent as twitterIcon } from "../../assets/twitter.svg";
import { ReactComponent as clipboardIcon } from "../../assets/clipboard.svg";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";

export default function ShareModal({ isVisible }) {
  const ctx = useContext(AppContext);
  const [copied, setCopied] = useState(false);
  const { toggleModal } = ctx;
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "black",
      border: "0px",
      width: "450px",
      height: "180px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "0px",
    },
    overlay: {
      backgroundColor: "rgba(71, 72, 79, 0.8)",
    },
  };
  const getLinkToShare = () => {
    return window.location.origin;
  };
  const whatsappShare = () => {
    let linkToShare = getLinkToShare();
    window.open(
      `https://api.whatsapp.com/send/?text=${linkToShare}`,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  const twitterShare = () => {
    let linkToShare = getLinkToShare();
    window.open(
      `https://twitter.com/share?url=${linkToShare}`,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  const emailShare = () => {
    let linkToShare = getLinkToShare();
    window.open(
      `mailto:?subject=Join me and help children affected by the Ukraine Conflict&body=${linkToShare}`,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  const copyLink = async () => {
    let linkToShare = getLinkToShare();
    await navigator.clipboard.writeText(linkToShare);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };
  const shareOptions = [
    // { name: "Share to Instagram", icon: instaIcon, action: instagramShare },
    { name: "Share to WhatsApp", icon: whatsappIcon, action: whatsappShare },
    { name: "Share to Twitter", icon: twitterIcon, action: twitterShare },
    { name: "Share via Email", icon: emailIcon, action: emailShare },
    { name: "Copy Link", icon: clipboardIcon, action: copyLink },
  ];
  return (
    <div className={styles.modal}>
      <Modal
        isOpen={isVisible}
        onRequestClose={() => {
          toggleModal(null);
        }}
        style={customStyles}
        contentLabel="Share Modal"
      >
        <h1 className={styles.modalTitle}>SPREAD THE WORD</h1>
        <div className={styles.options}>
          {shareOptions.map((opt, i) => (
            <div
              key={opt.name}
              className={`${styles.option} ${copied ? styles.copied : ""}`}
              onClick={opt.action}
            >
              <opt.icon />
              {copied && i == 3 && <b className={styles.copiedText}>Copied!</b>}
            </div>
          ))}
        </div>
        <CloseIcon className={styles.close} onClick={() => toggleModal(null)} />
      </Modal>
    </div>
  );
}
